export default {"src":"/_next/static/media/lifetime-trait.52b76cc3.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};